export default __webpack_public_path__ + "static/media/user-03.32e1e493.jpg";